import React from 'react';
import localization from '../lib/localization/localization'

export default function AuthButton({click_auth_button, ui_language}) {

    return (
        <button className="auth-button" onClick={async()=> await click_auth_button()}>
            {localization.localize(ui_language).connect}
        </button>
    );
}